module['exports'] = [
  '#{city_prefix} #{Name.first_name}#{city_suffix}',
  '#{city_prefix} #{Name.first_name}',
  '#{Name.first_name}#{city_suffix}',
  '#{Name.last_name}#{city_suffix}',
];
